/**
 * Assessment print route helper (opens in a new tab).
 */
export const assessmentPrintUrl = (patientId, chartId) => {
  const params = new URLSearchParams();
  if (chartId != null && chartId !== "") {
    params.set("chartId", String(chartId));
  }
  const q = params.toString();
  return `/patients/${patientId}/assessment/print${q ? `?${q}` : ""}`;
};
